import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/common/api-service/api.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-right-menu',
  templateUrl: './right-menu.component.html',
  styleUrls: ['./right-menu.component.scss']
})
export class RightMenuComponent implements OnInit, OnDestroy {
  subscription: Subscription[] = [];

  public notifications: any[] = [];
  public albums: any[] = [];
  public visits: any[] = [];

  /**
  * constructor
  * @param api
  */
  constructor(private api: ApiService,
    private router: Router) {
  }

  /**
   * ngOnInit
   */
  ngOnInit() {
    // first load
    this.subscription.push(this.api.sendDataService.language$.subscribe(language => {
      // load data news
      this.loadDataNews();
    }));

    // load data visitors
    this.loadDataVisitor();
  }

  /**
   * ngOnDestroy
   */
  ngOnDestroy() {
    this.subscription.forEach(item => {
      item.unsubscribe();
    });
  }


  /**
   * loadDataNews
   */
  loadDataNews() {
    // load data notification
    const param = {
      'siteid': 2,
      'lang': this.api.getLanguage(),
      'typeid': 1234, // 63 là thông báo
      'offset': 0,
      'limit': 5,
    };
    this.subscription.push(this.api.excuteAllByWhat(param, '100').subscribe(data => {
      if (data) {
        this.notifications = data;

        const currentDateTime = (new Date()).getTime();
        let postDateTime: number;
        let divDateTime: number;
        // process icon new
        this.notifications.forEach(item => {
          postDateTime = (new Date(item.postdate)).getTime();
          divDateTime = (currentDateTime - postDateTime) / (1000 * 3600 * 24);
          if (divDateTime < 5) {
            item.isNew = true;
          } else {
            item.isNew = false;
          }
        });
      }
    }));

    // load data albums
    const param4 = {
      'siteid': 2,
      'lang': this.api.getLanguage()
    };
    this.subscription.push(this.api.excuteAllByWhat(param4, '120').subscribe(data => {
      if (data) {
        data.forEach((item, index) => {
          if (index == 0) {
            item.style = 'carousel-item active';
          } else {
            item.style = 'carousel-item';
          }
        });
        this.albums = data;
      }
    }));
  }

  /**
   * load Data Visitor
   */
  loadDataVisitor() {
    // update visitor
    this.subscription.push(this.api.excuteAllByWhat({}, '221').subscribe(data => {
    }));

    // load visitor
    this.subscription.push(this.api.excuteAllByWhat({}, '220').subscribe(data => {
      this.visits = data[0]['visits'];
    }));
  }

  /**
   * on Link Change
   * @param event
   */
  onLinkChange(event) {
    // this.router.navigate([event.srcElement.value], {});
    window.open(event.srcElement.value, '_blank');
  }

  /**
   * on Title Click
   * @param url
   */
  onTitleClick(notification) {
    let formatTitle = this.api.cleanAccents(notification.title).split(' ').join('-');
    formatTitle = formatTitle.replace('/', '');
    const url = '/detail/news/' + formatTitle + '/' + notification.id + '/' + notification.typeid;
    this.router.navigate([url.toLowerCase()], { skipLocationChange: false });

    // notification to animation on menu component
    this.api.sendDataService.setDataSend('true');
  }

  /**
   * on Image Click
   * @param album
   */
  onImageClick(album) {
    const url = '/image/' + album.id;
    this.router.navigate([url.toLowerCase()], { skipLocationChange: false });

    // notification to animation on menu component
    this.api.sendDataService.setDataSend('true');
  }

}
